import React from "react";
import { useHistory, useParams } from "react-router-dom";

import { Typography } from "antd";

import { commonTabs } from "containers/Sales/earnings/tabs";
import styles from "components/PlatformLayout/components/PlatformPageHeader/PlatformPageHeader.module.less";

const { Title } = Typography;

const EarningsBreadCrumbs = () => {
  const params = useParams();
  const history = useHistory();

  const activeTab = commonTabs.find((t) => t.key === params.tab);

  const handleBaseNavigate = () => {
    history.push("/earnings");
  };

  const baseStyle = {
    cursor: "pointer",
    textTransform: "capitalize",
    fontWeight: 600,
  };

  return (
    <>
      <Title className={styles.title} style={baseStyle} onClick={handleBaseNavigate}>
        Earnings
      </Title>
      {activeTab && (
        <>
          <span className={styles.titleSeparator}>/</span>
          <Title className={styles.titleSecondary}>{activeTab.label}</Title>
        </>
      )}
    </>
  );
};

export default EarningsBreadCrumbs;
